import React, { useMemo, useState, useEffect } from "react";
import "./ChatTemplatePreview.css";

const SIZE_PRESETS = {
    sm: { width: 280, headerHeight: 120, maxTextHeight: 140, fontSize: 13 },
    md: { width: 340, headerHeight: 140, maxTextHeight: 180, fontSize: 14 },
    lg: { width: 420, headerHeight: 170, maxTextHeight: 240, fontSize: 14 },
};

export default function ChatTemplatePreview({
    template,
    valoresParametros,
    size = "md",
    width, // opcional (override)
    maxWidth, // opcional
    headerHeight, // opcional (override)
    maxTextHeight, // opcional (override)
    showLabels = false, // se quiser esconder "Prévia do texto" etc.
}) {
    const [headerImgErro, setHeaderImgErro] = useState(false);

    useEffect(() => {
        setHeaderImgErro(false);
    }, [template]);

    const preset = SIZE_PRESETS[size] || SIZE_PRESETS.md;

    const resolvedWidth = width ?? preset.width;
    const resolvedHeaderHeight = headerHeight ?? preset.headerHeight;
    const resolvedMaxTextHeight = maxTextHeight ?? preset.maxTextHeight;

    const headerImageUrl = useMemo(() => {
        const url =
            template?.metaWhatsAppTemplateUrlImageHeader ||
            template?.metaWhatsAppTemplate_urlImageHeader ||
            template?.urlImageHeader ||
            "";
        return (url || "").trim();
    }, [template]);

    const templateTexto = useMemo(() => {
        return (template?.metaWhatsAppTemplateTexto || template?.metaWhatsAppTemplate_texto || "").toString();
    }, [template]);

    const textoRenderizado = useMemo(() => {
        if (!templateTexto) return "";

        return templateTexto.replace(/\{\{(\d+)\}\}/g, (_, n) => {
            const ordem = Number(n);
            const val = valoresParametros?.[ordem];

            if (val == null || String(val).trim() === "") return `{{${ordem}}}`;
            return String(val);
        });
    }, [templateTexto, valoresParametros]);

    if (!template) return null;

    return (
        <div
            className={`wa-template-preview wa-template-preview--${size}`}
            style={{
                width: resolvedWidth,
                maxWidth: maxWidth ?? "100%",
                "--wa-font-size": `${preset.fontSize}px`,
                "--wa-header-height": `${resolvedHeaderHeight}px`,
                "--wa-text-max-height": `${resolvedMaxTextHeight}px`,
            }}
        >
            {showLabels && <div className="wa-template-preview__label">Template</div>}

            <div className="wa-bubble">
                {/* HEADER (MEDIA) */}
                {headerImageUrl ? (
                    headerImgErro ? (
                        <div className="wa-media wa-media--empty">
                            <span>Não foi possível carregar a mídia</span>
                        </div>
                    ) : (
                        <img
                            className="wa-media"
                            src={headerImageUrl}
                            alt="Imagem do cabeçalho do template"
                            onError={() => setHeaderImgErro(true)}
                            loading="lazy"
                        />
                    )
                ) : null}

                {/* BODY */}
                {templateTexto ? (
                    <div className="wa-body">
                        <div className="wa-text" title={textoRenderizado}>
                            {textoRenderizado}
                        </div>
                    </div>
                ) : (
                    <div className="wa-body">
                        <div className="wa-empty-text">Este template não possui texto cadastrado.</div>
                    </div>
                )}
            </div>
        </div>
    );
}
